import ApiClient from "../../ApiClient";

const STORAGE_KEY = "gmail_auth";
const MILLISECONDS_TO_SECONDS = 1000;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI =
  process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
  `${window.location.origin}/google/callback`;
// The callback page always loads on this fixed origin, regardless of which
// tenant subdomain opened the popup, so message listeners must check the
// event against this origin rather than their own window.location.origin.
export const GOOGLE_REDIRECT_ORIGIN = new URL(GOOGLE_REDIRECT_URI).origin;
const GMAIL_SCOPE =
  "openid email profile https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly";

export const getGmailOAuthUrl = () =>
  `https://accounts.google.com/o/oauth2/v2/auth` +
  `?response_type=code` +
  `&client_id=${GOOGLE_CLIENT_ID}` +
  `&redirect_uri=${encodeURIComponent(GOOGLE_REDIRECT_URI)}` +
  `&scope=${encodeURIComponent(GMAIL_SCOPE)}` +
  `&access_type=offline` +
  `&prompt=consent` +
  `&state=${encodeURIComponent(window.location.origin)}`;

export async function refreshGmailToken(refreshToken) {
  const resp = await ApiClient.post("/GoogleMeet/oauth/refresh", {
    refreshToken,
  });
  return resp.data.data;
}

export function getGmailAuth() {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setGmailAuth(token) {
  const expires_at =
    Math.floor(Date.now() / MILLISECONDS_TO_SECONDS) + token.expires_in;

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...token, expires_at })
  );
}

export function clearGmailAuth() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isExpired(token) {
  return !token?.expires_at ||
    Math.floor(Date.now() / 1000) >= token.expires_at;
}

export async function getValidGmailAccessToken() {
  const token = getGmailAuth();
  if (!token) return null;

  if (!isExpired(token)) return token.access_token;

  if (!token.refresh_token) {
    clearGmailAuth();
    return null;
  }

  try {
    const refreshed = await refreshGmailToken(token.refresh_token);
    setGmailAuth({ ...token, ...refreshed });
    return refreshed.access_token;
  } catch (err) {
    clearGmailAuth();
    return null;
  }
}
